import type { ReactNode } from 'react';
import { READER_FONT_ORDER, type ReaderFont } from '../app/fonts.js';
import { useServices } from '../app/services.js';

/**
 * H6: the reading-font picker is a native <select> — it scales past four
 * fonts and is accessible for free. Option labels are plain text on
 * purpose: per-option font rendering would force-load every face and
 * defeat H4's lazy loading.
 */
export function FontSelect(): ReactNode {
  const { t, settings, updateSettings } = useServices();
  return (
    <select
      className="select"
      aria-label={t('settings.font')}
      value={settings.font}
      onChange={(event) => updateSettings({ font: event.target.value as ReaderFont })}
    >
      {READER_FONT_ORDER.map((font) => (
        <option key={font} value={font}>
          {t(`settings.font.${font}`)}
        </option>
      ))}
    </select>
  );
}
